// extracted by mini-css-extract-plugin
export var actionText = "_po-4";
export var container = "_po-0";
export var leftSection = "_po-1";
export var rightSection = "_po-2";
export var settingsButton = "_po-6";
export var settingsIcon = "_po-7";
export var shortcut = "_po-5";
export var shortcutGroup = "_po-3";